var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body,html{height:100%}body{background-color:#fff;display:flex;width:100%;min-width:300px;align-items:center;padding-top:40px;background-image:url(" + escape(require("../img/wp_numbers3.jpg")) + ")}.code-box-border{border-color:#efefef!important;background-color:#fff;margin-left:auto;margin-right:auto;margin-top:auto;opacity:.85}#app{position:fixed;top:80px;bottom:15%;left:0;right:0;overflow:auto;padding-left:.5rem;padding-right:.5rem}.bg-light-custom{background-color:#9fc2f9!important}.card-header{padding-top:.35rem!important;padding-bottom:.35rem!important}.accordion-btn,.footer{width:100%}.footer{background-color:#f5f5f5;text-align:center}.custom-card,.custom-card:hover{color:inherit}.custom-card:focus{background-color:#bfe}.card-body-tries{padding:.5rem;padding-left:.8rem;padding-right:.8rem}.card-footer-tries{padding:0}.btn{border-radius:0}.lucky-numbers{font-size:1rem!important}.btn-loading{background-image:url(" + escape(require("../img/lding_blocks_1s_32px.gif")) + ")}.tab-buttons{padding:.25rem .75rem}nav div{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/site.css
// module id = 420
// module chunks = 0